<template>
    <div class="display-control">
        <!-- 显示排序 -->
        <ul class="display-sort">
            <template  v-for="(item,index) in sort_list">
                <li v-if="!$route.params.priority"
                    :key="index">
                    <a href="javascript:;"
                        @click="handleSort(item)"
                        :class="{
                            'selected-color': item.up == sort || item.down == sort
                        }">
                        {{item.label}}
                    </a>
                    <!-- 图标 -->
                    <i class="glyphicon glyphicon-arrow-down"
                        v-show="item.down === sort"></i>
                    <i class="glyphicon glyphicon-arrow-up"
                        v-show="item.up === sort"></i>
                </li>
            </template>
        </ul>
        <!-- 显示方式 -->
        <ul class="display-mode">
            <li class="mode-title">
                {{$t("message.plist.mode")}}
            </li>
            <li>
                <a href="javascript:;"
                    @click="handelMode(true)"
                    :class="{
                        'selected-color': value
                    }">
                    <i class="glyphicon glyphicon-th-large"></i>
                </a>
            </li>
            <li>
                <a href="javascript:;"
                    @click="handelMode(false)"
                    :class="{
                        'selected-color': !value
                    }">
                    <i class="glyphicon glyphicon-align-justify"></i>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                sort_list: [
                    {
                        label: this.$t("message.plist.sort1"),
                        up: 'asc',
                        down: ''
                    },
                    {
                        label: this.$t("message.plist.sort2"),
                        up: 'virtual_sales_asc',
                        down: 'virtual_sales_desc'
                    },
                    {
                        label: this.$t("message.plist.sort3"),
                        up: 'shop_price_asc',
                        down: 'shop_price_desc'
                    },
                    {
                        label: this.$t("message.plist.sort4"),
                        up: 'createtime_asc',
                        down: 'createtime_desc'
                    }
                ],
            }
        },
        props: {
            sort: String,
            value: Boolean
        },
        methods: {
            handleSort(item) {
                this.$emit('handleSort', item);
            },
            handelMode(value) {
                this.$emit('input', value);
            }
        },
    }
</script>

<style scoped>
.selected-color {
    color: #FF6700 !important;
}
.display-control {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
}
.display-sort > li {
    float: left;
    padding: 12px 40px;
    border-left: 1px solid #DCDFE6;
    color: #FF6700;
}
.display-sort > li:first-child {
    padding-left: 0;
    border-left: 0;
}
.display-sort > li > a {
    color: #333;
}
.display-mode {
    display: flex;
    justify-content: space-between;
    width: 160px;
}
.mode-title {
    color: #8c8c8c;
}
.display-mode  a {
    color: #909399;
}
</style>